<template>
  <div class="bk">
    <!-- ======== 原有导航栏 ======== -->
    <van-nav-bar
      title="题目详情"
      left-text="返回"
      left-arrow
      class="custom-navbar"
      @click-left="onBack"
    />
    <div v-show="isParsing" class="mytip">正在解析中，请稍候</div>
    <!-- ======== 题目卡片列表（左图右文 + 底部按钮） ======== -->
    <div v-if="questions.length > 0" class="question-list">
      <div v-for="(q, index) in questions" :key="index" class="question-card">
        <!-- 左侧图片（增加点击预览） -->
        <div class="card-left" @click="previewImage(q.picpath)">
          <van-image
            :src="q.picpath || 'https://img.yzcdn.cn/vant/cat.jpeg'"
            fit="cover"
            class="card-image"
           
            width="100%"
            height="100%"
          />
        </div>
        <!-- 右侧内容-->
        <div class="card-right">
          <div class="right-content">
            <!-- 对错标记 -->
            <div class="right-top">
              <span v-if="q.blok === '正确'" class="tag-correct">✔ 正确</span>
              <span v-else-if="q.blok=== '错误'" class="tag-wrong">✘ 错误</span>
              <span v-else class="tag-pending">未作答</span>
            </div>
            <!-- 答案 -->
            <div class="right-answer">
              <span class="label">答案：</span>
              <span class="answer-value">{{ q.answer || '未作答' }}</span>
            </div>
            <!-- 解析 -->
            <div class="right-solution">
              <span class="label">解析：</span>
              <span class="solution-text">{{ q.jiexi || '暂无解析' }}</span>
            </div>
          </div>

          <!-- 底部按钮组 -->
          <div class="right-actions">
            <van-button
              size="small"
              round
              plain
              type="primary"
              icon="star-o"
              @click="handleCollect(q, index)"
            >
              收藏
            </van-button>
            <van-button
              size="small"
              round
              type="warning"
              icon="edit"
              @click="handleGenerate(q, index)"
            >
              出题
            </van-button>
          </div>
        </div>
      </div>
    </div>
    <!--<div v-else class="empty-state">
      <van-icon name="info-o" size="40" style="color:#c8c9cc;margin-bottom:12px;" />
      <div>正在分析题目，请稍候！</div>
    </div>-->
  </div>
</template>

<script>
import axios from "axios";
import { getCurrentInstance, ref, onMounted } from "vue";
// ======== 新增：导入图片预览组件 ========
import { showImagePreview } from "vant/es/image-preview";
import "vant/es/image-preview/style";
import { showSuccessToast} from "vant/es/toast";
import "vant/es/toast/style";
/*import { showNotify, closeNotify } from 'vant/es/notify'
// 单独引入样式
import 'vant/es/notify/style'*/

export default {
  name: "Login",
  setup() {
    const { proxy } = getCurrentInstance();
    const list = ref([]);      // 原有：图片URL列表
    const answer = ref(null);  // 原有：智能体返回结果

    // ======== 题目数据 ========
    const questions = ref([]);
const isParsing = ref(false)
/*
    // 统一解析加载提示
const showParseTip = () => {
  showNotify({
    message: '正在解析中，请稍候',
    duration: 0,
    position: 'top'
  })
}

const hideParseTip = () => {
  closeNotify()
}*/
    // ---------- 原有方法 ----------
    const onBack = () => {
     // proxy.$router.meta.needRefresh = true
      proxy.$router.go(-1);
       // 下一次进入强制刷新组件

    };
// 页面激活（再次进入缓存页面触发）
/*onActivated(() => {
  if (proxy.$router.meta.needRefresh) {
    // 先复位标记，防止无限循环
    proxy.$router.meta.needRefresh = false
    // 添加随机时间戳，路由识别为全新页面，抛弃缓存
    proxy.$router.replace({
      path: proxy.$router.path,
      query: {
        _t: Date.now()
      }
    })
  }
})*/
    const getfx = async () => {
      const myoption = {
        inputs: { blType: "200" },
        query: "1",
        response_mode: "blocking",
        conversation_id: "",
        user: "abc-123",
        files: [],
      };

      const route = proxy.$route;

      // 解析 query 中的 data（原有逻辑）
      try {
        list.value = JSON.parse(route.query.data || "[]");
      } catch (e) {
        console.error("解析失败", e);
        list.value = [];
      }

      // 智能体请求
      questions.value = [];
      for (var i = 0; i < list.value.length; i++) {
        myoption.files = [];
        myoption.files.push({
          url: list.value[i],
          transfer_method: "remote_url",
          type: "image",
        });
        try {
          const response = await axios.post("https://agent.gjt-smart.com/v1/chat-messages", myoption, {
            headers: { Authorization: "Bearer app-hbVnpcx6R0YocpD6eO8SCOzv" },
          });
          answer.value = JSON.parse(response.data.answer);
          //console.log(answer.value);
          questions.value.push({
            blok: answer.value[0].blok,
            answer: answer.value[0].answer,
            jiexi: answer.value[0].jiexi,
            picpath:answer.value[0].picpath
            // 可添加其他字段，如 isCorrect 等（由业务决定）
          });
          //console.log(questions.value);
        } catch (error) {
          console.error(error);
        }
      }
       isParsing.value = false;//取消显示正在解析
    };

    // ======== 新增：图片预览方法 ========
    const previewImage = (imageUrl) => {
      if (!imageUrl) {
        //vant.showToast('图片地址无效');
        return;
      }
    /*  showImagePreview({
        images: [imageUrl],
        closeable: true,
        showIndex: false,
      }).catch(() => {});*/
      showImagePreview({
        images: [imageUrl],
        closeable: true,
        showIndex: false,
      });
    };

    // ======== 按钮事件 ========
    const handleCollect = (q, index) => {
      // vant.showToast(`已收藏题目 ${index+1}`);
      console.log('收藏', q, index);


      var tminfo=JSON.parse(localStorage.getItem('tmInfo'));//先取出
      if(!tminfo) tminfo=[];
      tminfo.unshift(q);//添加新记录到头部
      localStorage.setItem('tmInfo', JSON.stringify(tminfo));//再保存回去

      showSuccessToast("收藏成功！");

    };

    const handleGenerate = (q, index) => {
      // vant.showToast(`基于题目 ${index+1} 生成相似题`);
      //console.log('出题', q, index);
      console.log('出题', q, index);
      if(isParsing.value) return;
      // 进入下一页，传递数据
      proxy.$router.push({
        path: '/showtz',
        query: { data: JSON.stringify(q) },
      });
    };

    // ---------- 生命周期 ----------
    onMounted(() => {
       isParsing.value = true//显示正在解析
      getfx(); // 请求智能体
 
    });

    return {isParsing, answer, list, getfx, onBack, questions, handleCollect, handleGenerate, previewImage };
  },
};
</script>

<!-- ======== 样式（新增点击指针样式） ======== -->
<style scoped>
.question-list {
  padding: 16px;
  background-color: #f5f6fa;
}

.question-card {
  display: flex;
  background: #ffffff;
  border-radius: 16px;
  padding: 14px;
  margin-bottom: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  align-items: stretch;
  min-height: 120px;
}

.card-left {
  flex: 0 0 100px;
  height: 100px;
  margin-right: 14px;
  border-radius: 12px;
  overflow: hidden;
  background: #f0f2f5;
  cursor: pointer; /* 新增：鼠标悬停显示手型 */
}

.card-image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100px;
}

.right-content {
  flex: 1;
}

.right-top {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.tag-correct {
  color: #07c160;
  background: #f0faf4;
  padding: 2px 12px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 600;
}

.tag-wrong {
  color: #ee0a24;
  background: #fef0f0;
  padding: 2px 12px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 600;
}

.tag-pending {
  color: #969799;
  background: #f5f6fa;
  padding: 2px 12px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 500;
}

.right-answer,
.right-solution {
  font-size: 14px;
  color: #323233;
  line-height: 1.6;
  margin-top: 4px;
}

.right-answer .label,
.right-solution .label {
  color: #646566;
  font-weight: 500;
  margin-right: 4px;
}

.answer-value {
  font-weight: 600;
  color: #4a6cf7;
}

.solution-text {
  color: #4a4a5a;
  word-break: break-word;
}

.right-actions {
  display: flex;
  justify-content: flex-end;
  
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px solid #f0f2f5;
}

/* 核心代码：选中除了第一个以外的所有直接子元素，添加左边距 */
.right-actions > * + * {
  margin-left: 10px;
}

.right-actions .van-button {
  font-size: 12px;
  padding: 0 16px;
  height: 28px;
  line-height: 28px;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #969799;
  font-size: 15px;
}

/* 小屏适配 */
@media (max-width: 380px) {
  .card-left {
    flex-basis: 80px;
    height: 80px;
  }
  .right-answer,
  .right-solution {
    font-size: 13px;
  }
}
.mytip{
   height: 25px;
   width: 100%;
   line-height: 25px;
   background-color: rgba(247, 67, 67, 0.911);
   color: white;
   font-size: 16px;
   text-align: center;
}

</style>